import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { ClientStatusResponse } from '@shared/api/clientStatus.api.ts';
import { getApiClientStatus } from '@shared/api/clientStatus.api.ts';
import { extractError } from '@utils/slice.ts';

interface ClientStatusSlice {
    isLoading: boolean;
    error: Record<string, any> | null;
    clientStatus: ClientStatusResponse | null;
}

const initialState: ClientStatusSlice = {
    isLoading: false,
    error: null,
    clientStatus: null,
};

export const getClientStatus = createAsyncThunk<ClientStatusResponse, void, { rejectValue: any }>(
    'client/getClientStatus',
    (_, { rejectWithValue }) =>
        getApiClientStatus()
            .then((res) => res)
            .catch((err) => rejectWithValue(err)),
);

const clientStatusSlice = createSlice({
    name: 'client',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getClientStatus.fulfilled, (state, action) => {
            state.clientStatus = action.payload;
        });
        builder.addCase(getClientStatus.pending, (state) => {
            state.error = null;
            state.isLoading = true;
        });
        builder.addCase(getClientStatus.rejected, (state, action) => {
            state.isLoading = false;
            state.error = extractError(action);
        });
    },
});

export default clientStatusSlice.reducer;
